import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
export type UpdateAccountMemberProfileInformationMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.UpdateAccountMemberProfileInformationInput;
}>;

export type UpdateAccountMemberProfileInformationMutationResult = { __typename?: 'Mutation' } & {
  updateAccountMemberProfileInformation?: GraphQLTypes.Maybe<
    { __typename?: 'UpdateAccountMemberProfileInformationPayload' } & {
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
    }
  >;
};

export const UpdateAccountMemberProfileInformationDocument = gql`
  mutation updateAccountMemberProfileInformation($input: UpdateAccountMemberProfileInformationInput!) {
    updateAccountMemberProfileInformation(input: $input) {
      errors {
        message
        path
      }
    }
  }
`;
